// Auto-generated normalizer for table: Cat_Proyectos
export function catProyectosNormalize(row) {
  return {
    idProyecto: row.idProyecto ?? row.IdProyecto ?? row['IdProyecto'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    fechaInicio: row.fechaInicio ?? row.FechaInicio ?? row['FechaInicio'] ?? null,
    fechaFin: row.fechaFin ?? row.FechaFin ?? row['FechaFin'] ?? null,
    estado: row.estado ?? row.Estado ?? row['Estado'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
